import { render, staticRenderFns } from "./SmsSender.vue?vue&type=template&id=4a1922c2&"
import script from "./SmsSender.vue?vue&type=script&lang=js&"
export * from "./SmsSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports